
(function($){

  /////////////////////////////////////-+++-
  // Responsive resize utility function
  // fire something after the event has ended, often used for at the end of a window resize.
  // via http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed

      var waitForFinalEvent = (function () {
          var timers = {};
          return function (callback, ms, uniqueId) {
              if (!uniqueId) {
                  uniqueId = "Don't call this twice without a uniqueId";
              }
              if (timers[uniqueId]) {
                  clearTimeout (timers[uniqueId]);
              }
              timers[uniqueId] = setTimeout(callback, ms);
          };
      })();

      //sample usage:
      // $(window).resize(function () {
      //     waitForFinalEvent(function(){
      //       alert('Resize...');
      //       //...
      //     }, 500, "some unique string");
      // });

  /////////////////////////////////////-+++-
  // Fitvids
  // this plugin makes all videos (iframes) responsive inside the main content area
  // relies on jquery.fitvids plugin
      $('body').fitVids();



  /////////////////////////////////////-+++-
  // Objectfit polyfill
  // https://github.com/bfred-it/object-fit-images
    objectFitImages();

  ///////////////////////////////////////-+++-
  // height equalization for the mobile menu trigger and breadcrumbs

      if( $('.interior-nav').length ) {
          $('.interior-nav, .header__offcanvas-trigger').matchHeight();
      }


  /////////////////////////////////////-+++-
  // Video reveal on campaign components
  //
      if ( $('.campaign__video').length ) {
          var $iframe = $('.campaign__video').find('iframe').attr('src');

          // parse the iframe src to remove all params
          var substring = "?";
          var position = $iframe.indexOf(substring);

          if ($iframe.indexOf(substring) !== -1) {
              // the iframe src has some params lets remove them (everything after the '?')
              $iframe = $iframe.substring(0, position != -1 ? position : $iframe.length);
          } else {
              // do nothing, the iframe src is already param-less
          }

          $('.campaign__image-poster').click(function(e) {
              var controls = 0
              var $video = $('.campaign__video')
              var src = $video.find('iframe').attr('src')

              if (src.match('vimeo')) {
                // Needed or else you can't pause Vimeo videos.
                controls = 1
              }

              $video.find('iframe').attr('src', $iframe + '?rel=0;&controls=' + controls + ';&showinfo=0;autoplay=1');
              $(this).closest('.campaign').addClass('js-show-video');
          });
      }


///////////////////////////////////////-+++-
// Close Pushdown

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  var expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

if ($('.large-pushdown').length) {

  // Closing the pushdown and setting cookie.
  var bid = $('.large-pushdown').attr('id');

  $('.large-pushdown__close').click(function () {
    $('.large-pushdown').slideUp('fast');
    setCookie('pushdown' + bid + 'collapsed', '1', 7);
  });
  if (!getCookie('pushdown' + bid + 'collapsed')) {
    $('.large-pushdown').removeClass('visually-hidden');
  }
}

// Same thing but for the small pushdown.
if ($('.pushdown').length) {

  // Closing the pushdown and setting cookie
  var bid = $('.pushdown').attr('id');

  $('.pushdown__close').click(function () {
    $('.pushdown').slideUp('fast');
    setCookie('pushdown' + bid + 'collapsed', '1', 7);
  });
  if (!getCookie('pushdown' + bid + 'collapsed')) {
    $('.pushdown').removeClass('visually-hidden');
  }
}

  ///////////////////////////////////////-+++-
  // Modal

  var $modals = $('.modal');
  if ($modals.length) {

    var paladinModalClose = function($modal) {
      $modal.removeClass("is-open");
      var $overlay = $('.modal-overlay').removeClass("is-open");
      setTimeout(function(){
        $modal.removeClass("is-display");
        $overlay.removeClass("is-display");
      }, 400);
    }

    $modals.each(function() {
      var $modal = $(this);

      $modal.find('.modal__close').click(function () {
        var $modal = $(this).closest('.modal');
        paladinModalClose($modal);
      })

      // Any links that have a # as the URL act as close links.
      $modal.find('.button[href^="#"]').click(function (ev) {
        ev.preventDefault();
        var $modal = $(this).closest('.modal');
        paladinModalClose($modal);
      })
    })
  }

  ///////////////////////////////////////-+++-
  // Open and close navigation items in the header and interior-nav offcanvas nav
  // making the header offcanvas sticky

  if ( $('.header__offcanvas-area').length ) {

    var stickyNav = (function () {
      if (stickyNavElement) {
        stickyNavElement.destroy();
      }

      if($(window).width() < 1050){
        var stickyNavElement = new Waypoint.Sticky({
          element: $('.header__offcanvas-area')[0],
          offset: 0
        })
      }
    });

    $(document).ready(function () {
      stickyNav();
    });

    $(window).resize(function () {
        waitForFinalEvent(function(){
          stickyNav();
        }, 500, "deploy sticky nav");
    });


    // close offcanvas nav items after page load if on homepage
    if ($('body').hasClass('path-frontpage')) {
      setTimeout(function() {
        $('.header__offcanvas-nav>ul>li.menu-item--expanded>button').click();
        $('.header__offcanvas-nav>ul>li.menu-item--expanded').removeClass('is-open');
      }, 500);
    }

    $('.header__offcanvas-close').each(function () {
      $(this).attr('tabindex', -1);
    });

    // for the global header on mobile
    $('.header__offcanvas-trigger').click(function () {
      $this = $(this);

      //$offcanvas_height = $('.header__offcanvas-content-inside').outerHeight();
      $('body').addClass('offcanvas-open');
      //$('.page-wrapper').height($offcanvas_height);

      $this.closest('.header').addClass("is-display");
      $this.attr("aria-expanded", "true");
      $('.header__offcanvas-content').attr("aria-expanded", "true");

      // set all inner buttons to false
      $('.header__offcanvas-nav').find('button').attr("aria-expanded", "false");

      setTimeout(function(){
        $this.closest('.header').addClass("is-open");
        $('.header__offcanvas-close').attr('tabindex', 0);
      }, 100);
    });

    $('.header__offcanvas-close, .header__offcanvas-overlay').click(function () {
      $this = $(this);

      $('body').removeClass('offcanvas-open');
      $this.attr('tabindex', -1);

      // add aria attributes
      $this.closest('.header').removeClass("is-open");
      $('.header__offcanvas-trigger').attr("aria-expanded", "false");
      $('.header__offcanvas-content').attr("aria-expanded", "false");

      setTimeout(function(){
        $this.closest('.header').removeClass("is-display");
      }, 400);

      // Return focus to the trigger after the main menu is closed.
      $('.header__offcanvas-trigger').focus();
    });

    $('.header__offcanvas-nav button').click(function () {
      $(this).closest('li').toggleClass("is-open");
      $(this).closest('li').find('ul').eq(0).slideToggle('fast');

      // if the li has an is-open class, find the closest button and add aria-expanded=true.
      if($(this).closest('li').hasClass("is-open")) {
        $(this).closest('button').attr("aria-expanded", "true");
      } else {
        $(this).closest('button').attr("aria-expanded", "false");
      }
    });

    // Support keyboard navigation in the main menu.
    $('.menu-item__submenu-toggle').click(function () {
      var ariaExpanded = $(this).attr("aria-expanded");

      if (ariaExpanded === "true") {
        $(this).attr("aria-expanded", "false");
      } else {
        $(this).attr("aria-expanded", "true");
      }
    });

    $('.menu-item--with-sub').on('mouseenter', function () {
      $(this).find('.menu-item__submenu-toggle').attr('aria-expanded', 'true');
    });

    $('.menu-item--with-sub').on('mouseleave', function () {
      $(this).find('.menu-item__submenu-toggle').attr('aria-expanded', 'false');
    });

    $(".menu-item__link--sub, .menu-item__submenu-toggle").on("focus blur", function () {
      $self = $(this);
      // Using setTimeout with 0 to ensure the focus change is processed first.
      // This prevents any timing issues before executing the logic.
      setTimeout(function () {
        if (!$(".menu-item__link--sub:focus").length) {
          var $submenuToggle = $self.closest('.menu-item--with-sub').find('.menu-item__submenu-toggle');
          if ($submenuToggle.length && $submenuToggle.attr('aria-expanded') === 'true') {
            $submenuToggle.attr('aria-expanded', 'false');
          }
        }
      }, 0);
    });

    // Prevent navigating through the main menu twice.
    $(".sticky-header__donate-button").on("focus", function (e) {
      var previousElement = e.relatedTarget;

      // Check if the previous focus is NOT inside .sticky-header.
      if (previousElement && !$(previousElement).closest('.sticky-header').length) {
        var lastMenuItem = $('.menu-item__link--base').last();
        var submenuButton = lastMenuItem.parent().find('> button');

        // Set focus to the submenu button if it exists,
        // or fallback to the link of the last menu item if no submenu is available.
        if (submenuButton.length) {
          submenuButton.focus();
        } else {
          lastMenuItem.focus();
        }
      }
    });

    // Prevent focus outside the main menu when open on mobile.
    $(".interior-nav__offcanvas-close, .header__offcanvas-close").on("keydown", function(event) {
      if (event.key === "Tab") {
        event.preventDefault();

        if ($(this).hasClass('interior-nav__offcanvas-close')) {
          $('.interior-nav__offcanvas-logo > a').focus();
        } else {
          $('.header__offcanvas-logo > a').focus();
        }
      }
    });

    $(".interior-nav__offcanvas-logo > a, .header__offcanvas-logo > a").on("keydown", function(event) {
      if (event.key === "Tab" && event.shiftKey) {
        event.preventDefault();

        if ($(this).parent().hasClass('interior-nav__offcanvas-logo')) {
          $('.interior-nav__offcanvas-close').focus();
        } else {
          $('.header__offcanvas-close').focus();
        }
      }
    });

    // Close all open submenus when the Escape key is pressed.
    $(document).keydown(function (event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        $('.menu-item__submenu-toggle').each(function () {
          if ($(this).attr('aria-expanded') === 'true') {
            $(this).attr('aria-expanded', 'false');
            $(this).focus();
          }
        });

        $('.interior-nav__offcanvas-content, .header__offcanvas-content').each(function () {
          if ($(this).attr('aria-expanded') === 'true') {
            if ($(this).hasClass('interior-nav__offcanvas-content')) {
              $(".interior-nav__offcanvas-close").click();
              $(".interior-nav__offcanvas-trigger").focus();
            } else {
              $(".header__offcanvas-close").click();
              $(".header__offcanvas-trigger").focus();
            }
          }
        });
      }
    });
  }

  // Support for the new "Election 2024" menu item.
  var $mainMenu = $('.menu--main ul');

  // Handle media query matches.
  function mediaQueryHandler(query) {
    // Select the "Election 2024" link from the main menu.
    var $electionLink = $mainMenu.children().filter(function() {
      return /(Election 2024|Elecciones 2024)/.test($(this).text());
    }).find('a');

    // Change the link color based on screen size.
    if ($electionLink.length) {
      var newColor = query.matches ? '#e7131a' : '#ffffff'; // Red for desktop, white for mobile.
      $electionLink.css('color', newColor);
    }
  }

  // Create media query, add listener.
  var mq = window.matchMedia('(min-width: 1273px)');
  mq.addEventListener('change', mediaQueryHandler);
  mediaQueryHandler(mq);

  // Adds open and close functionality to the search wrapper,
  // when the main menu has more than 4 items.
  if ($mainMenu && $mainMenu.children().length > 4) {
    var $searchForm = $(".sticky-header__search");
    var $searchToggle = $(".sticky-header__toggle");

    $searchToggle.addClass("active");
    $searchForm.addClass("closed support-five-menu-items");

    $searchToggle.on("click", function () {
      if ($searchForm.hasClass("closed")) {
        $searchForm.removeClass("closed");
        $searchToggle.addClass("open");
        $searchForm.find("input").focus();
      } else {
        $searchForm.addClass("closed");
        $searchToggle.removeClass("open");
      }
    });

    $searchForm.keydown(function (event) {
      if (
        (event.key === "Escape" || event.keyCode === 27) &&
        $searchForm && $searchToggle
      ) {
        $searchForm.addClass("closed");
        $searchToggle.removeClass("open");
      }
    });
  }
  // End of support for the new "Election 2024" menu item.

  // for the interior nav on desktop
  if ($('.interior-nav').length) {

    $('.interior-nav__offcanvas-trigger').click(function () {
      $this = $(this);

      // add aria attributes
      $this.attr("aria-expanded", "true");
      $('.interior-nav__offcanvas-content').attr("aria-expanded", "true");
      $('.interior-nav__offcanvas-content-inside').attr("aria-expanded", "true");

      // set all inner buttons to false unless they are active
      $('.interior-nav__offcanvas-content-inside').find('button').attr("aria-expanded", "false");

      $offcanvas_height = $('.interior-nav__offcanvas-content-inside').outerHeight();
      $('body').addClass('offcanvas-open');
      $('.page-wrapper').height($offcanvas_height);

      $this.closest('.interior-nav').addClass("is-display");
      setTimeout(function(){
        $this.closest('.interior-nav').addClass("is-open");

        $(".interior-nav__nav > ul > li > ul > li").each(function (i) {
            var $li = $(this);
            setTimeout(function () { $li.addClass('is-in'); }, 50 * (i + 1));
        });

      }, 100);

      if($('.interior-nav__offcanvas-content-inside ul > li > ul > li').hasClass('is-open')) {
        $('.interior-nav__offcanvas-content-inside ul > li > ul > li.is-open > button').attr("aria-expanded", "true");
      }
    })

    $('.interior-nav__offcanvas-close, .interior-nav__offcanvas-overlay').click(function () {
      $this = $(this);

      $('body').removeClass('offcanvas-open');
      $('.page-wrapper').css('height','auto');

      // add aria attributes = false
      $('.interior-nav__offcanvas-trigger').attr("aria-expanded", "false");
      $('.interior-nav__offcanvas-content').attr("aria-expanded", "false");
      $('.interior-nav__offcanvas-content-inside').attr("aria-expanded", "false");

      $this.closest('.interior-nav').removeClass("is-open");
      setTimeout(function(){
        $this.closest('.interior-nav').removeClass("is-display");
        $(".interior-nav__nav > ul > li > ul > li").removeClass("is-in");
      }, 400);
    })

    $('.interior-nav__nav button').click(function () {
      $(this).closest('li').toggleClass("is-visually-open");
      $(this).closest('li').find('ul').eq(0).slideToggle('fast');

      // if the li has an is-open class, find the closest button and add aria-expanded=true.
      if($(this).closest('li').hasClass("is-visually-open", "is-open")) {
        $(this).closest('button').attr("aria-expanded", "true");
      } else {
        $(this).closest('button').attr("aria-expanded", "false");
      }

      setTimeout(function(){
        $offcanvas_height = $('.interior-nav__offcanvas-content-inside').outerHeight();
        $('.page-wrapper').height($offcanvas_height);
      }, 400);
    })
  }

  ///////////////////////////////////////-+++-
  // Smooth Scroll
    $('.mega-menu ul').masonry({
      // options
      itemSelector: '.mega-menu li'
    });


  ///////////////////////////////////////-+++-
  // Smooth Scroll
  $('.smooth-scroll').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: $($(this).attr('href')).offset().top}, 1000);
    $('.smooth-scroll').removeClass('active');
    $(this).addClass('active');
  });

  /////////////////////////////////////-+++-
  // Sticky Header

  if ($('.header__sticky-area').length) {

    var stickyHeader = (function () {
      if($(window).width() >= 1050){
        if ($(window).scrollTop() >= $('.header__sticky-area').position().top) {
          $('.sticky-header').addClass('active');
        } else {
          $('.sticky-header').removeClass('active');
        }

        $(window).scroll(function(){
          if ($(window).scrollTop() >= $('.header__sticky-area').position().top) {
            $('.sticky-header').addClass('active');
          } else {
            $('.sticky-header').removeClass('active');
          }
        });
      }
    });

    $(document).ready(function () {
      stickyHeader();
    });

    $(window).resize(function () {
        waitForFinalEvent(function(){
          stickyHeader();
        }, 500, "deploy sticky header");
    });

  }

  ///////////////////////////////////////-+++-
  // Sticky in page navbar

      if ($('.in-page-nav').length) {

        var stickyInPageNav = (function () {
          if (stickyInPageNavElement) {
            stickyInPageNavElement.destroy();
          }

          if($(window).width() >= 780 && $(window).width() < 1050){
            var stickyInPageNavElement = new Waypoint.Sticky({
              element: $('.in-page-nav__inside1')[0],
              offset: 0
            })
          } else if ($(window).width() >= 1050){
            var stickyInPageNavElement = new Waypoint.Sticky({
              element: $('.in-page-nav__inside1')[0],
              offset: 64
            })
          }
        });

        $(document).ready(function () {
          stickyInPageNav();
        });

        $(window).resize(function () {
            waitForFinalEvent(function(){
              stickyInPageNav();
            }, 500, "deploy sticky in page nav");
        });
      }

  /////////////////////////////////////-+++-
  // smoothscroll on the header

    $(document).ready(function () {
      $('.in-page-nav a').smoothScroll({offset: -150});
    });

  /////////////////////////////////////-+++-
  // Active scroll states for the navigation
  // the nav items need to change their active state depending on what is in view on the screen or their scroll position
  // this uses jquery waypoints to switch the active class - active style handled by css

    $(document).ready(function () {
      if ( $( ".in-page-nav" ).length ) {

          // first we need a function to handle switching between active states
          var switchActive = function(theid) {
              // remove active state from all nav items
              $('.in-page-nav li').removeClass('active');
              // grab the ID of the current chapter in view, and select the element in the nav that links to it,
              // then apply the active class to its parent
              $('.in-page-nav li a[href="#' + theid + '"]').parent().addClass("active");
          };

          // next we need some events to trigger the switch
          // when scrolling down, we trigger the switch at the top of each chapter
          var scrollstatedown = $('.chapter').waypoint({
              handler: function(direction) {
                  if (direction === 'down') {
                      switchActive(this.element.id);
                  }
              },
              offset: 150  // the 100 here is a magic number
          });
          // when scrolling up, we trigger at the bottom  (thus the offset value)
          var scrollstateup = $('.chapter').waypoint({
              handler: function(direction) {
                  if (direction === 'up') {
                      switchActive(this.element.id);
                  }
              },
              offset: function() {
                  return -this.element.clientHeight + 150; // the 100 here is a magic number
              }
          });

      } // ends the wrapping if statement
    });



    // if ($('.in-page-nav').length) {
    //   var navLoc = $('.in-page-nav').position().top + $('.sticky-nav').outerHeight();
    //   $(window).scroll(function(){
    //     if ($(window).scrollTop() >= navLoc) {
    //         $('.in-page-nav').addClass('active');
    //     } else {
    //         $('.in-page-nav').removeClass('active');
    //     }
    //   });
    // }

  ///////////////////////////////////////-+++-
  // Accordion


    function checkAccordion($element) {

      var $accordionContent = $element.find('.accordion__content');
      var $accordionFooter = $element.find('.accordion__footer');
      $accordionContent.removeClass('collapsed');
      $accordionContent.removeAttr("style");
      var accordionHeight = $accordionContent.outerHeight();

      if (accordionHeight > 450) {
        $accordionContent.addClass('collapsed');
        $accordionContent.css("height", "450px");
        $accordionFooter.show();
      } else {
        $accordionFooter.hide();
      }
    }

    if ($(document).find('.accordion').length) {

      $(document).find('.accordion').each( function(index) {

        var $accordion = $(this);
        var $accordionButton = $accordion.find('.accordion__button');
        var $accordionContent = $accordion.find('.accordion__content');
        var $accordionFooter = $accordion.find('.accordion__footer');
        var origAccordionHeight = $accordionContent.outerHeight();

        $( document ).ready(function() {
          checkAccordion($accordion);
        });

        $accordionButton.on('click', function() {
            if ($(this).hasClass('active')) {
                $accordionContent.addClass('collapsed');
                $accordionFooter.removeClass('is-expanded');
                $(this).removeClass('active');
                $accordionContent.css("height", "450px");
            } else {
                $accordionContent.removeClass('collapsed');
                $accordionFooter.addClass('is-expanded');
                $(this).addClass('active');
                $accordionContent.css("height", origAccordionHeight);
            }
        });

      });
    }

    // Accordion for Search Filters
    // var labelID;
    // $('.label-button').click(function() {
    //   labelID = $(this).attr('for');
    //   $('#'+labelID).trigger('click');
    // });
    //
    // $('.search-filters__accordion-button').on('click', function() {
    //   $(this).toggleClass('active').parent().find('.accordion__list:first').toggleClass('collapsed');
    // });

  /////////////////////////////////////-+++-
  // Footnotes
  // if ($('.page-body .accordion-list--end-notes').length) {

  //   $endnotes_div = $('<div class="accordion accordion-list chapter accordion-list--end-notes end-notes-div" id="end-notes">\n' +
  //     '        <div class="accordion-list__inside container-small">\n' +
  //     '        <header class="accordion-list__header">\n' +
  //     '        <h2 class="accordion-list__title chapter__title" data-swiftype-index="false">' + Drupal.t("Endnotes") + '</h2>\n' +
  //     '      </header><ul class="accordion__content accordion-list__list"></ul>\n' +
  //     '<footer class="accordion__footer accordion-list__footer" style="display: none;" data-swiftype-index="false">\n' +
  //     '        <button type="button" class="accordion__button accordion-list__button">\n' +
  //     '        ' + Drupal.t("See More") + '\n' +
  //     '      <svg role="img" focusable="false" aria-hidden="true">\n' +
  //     '        <use xlink:href="/themes/custom/paladin/patternlab/public/images/svg-symbols.svg#icon-button-plus"></use>\n' +
  //     '        </svg>\n' +
  //     '        <span class="accordion-list__button-active-state">\n' +
  //     '        ' + Drupal.t("See Less") + '\n' +
  //     '      <svg role="img" focusable="false" aria-hidden="true">\n' +
  //     '        <use xlink:href="/themes/custom/paladin/patternlab/public/images/svg-symbols.svg#icon-button-minus"></use>\n' +
  //     '        </svg>\n' +
  //     '        </span>\n' +
  //     '        </button>\n' +
  //     '        </footer></div></div>');

  //   // get all the <li> from the exisiting endnote sections and add to new div
  //   var $endnotes = $('.accordion-list--end-notes');

  //   // Add new endnotes div to bottom the content main field.
  //   $('.field-content__main').append($endnotes_div);

  //   $endnotes.each(function(i, e){
  //     var $endnote = $(this).detach();
  //     var $notes = $endnote.find('li.accordion-list__list-item');
  //     $('.end-notes-div ul').append($notes);
  //   });

  //   // iterate the footnotes in the page body
  //   var $footnotes = $('.page-body .footnote');
  //   $footnotes.each(function(i,e){
  //     var $this = $(this);
  //     var oldVal = $this.find('.footnote__label a').text();
  //     var newVal = ++i;
  //     var endnote_id = $this.find('.footnote__label a').prop('href').split('#')[1];
  //     $endnote_match = $('#' + endnote_id + ' h3');
  //     if (typeof $endnote_match !== 'undefined') {
  //       $('#' + endnote_id + ' h3').text(newVal);
  //     }
  //     $this.find('.footnote__label a').text(newVal);
  //   });

  //   // Remove ID from accordion list item as it's only used to increment count
  //   // and display that number.
  //   $('.end-notes-div .accordion-list__list-item').removeAttr('id');

  //   // This is a duplicate of the checkAccordion code earlier in app.js, but needed
  //   // because the div is added after the dom is loaded
  //   var $endNotesAccordion = $('.end-notes-div');
  //   var $endNotesAccordionButton = $endNotesAccordion.find('.accordion__button');
  //   var $endNotesAccordionContent = $endNotesAccordion.find('.accordion__content');

  //   $( document ).ready(function() {
  //     checkAccordion($endNotesAccordion);
  //   });

  //   $endNotesAccordionButton.on('click', function() {
  //     if ($(this).hasClass('active')) {
  //       $endNotesAccordionContent.addClass('collapsed');
  //       $(this).removeClass('active');
  //       $endNotesAccordionContent.css("height", "450px");
  //     } else {
  //       $endNotesAccordionContent.removeClass('collapsed');
  //       $(this).addClass('active');
  //       $endNotesAccordionContent.css("height", 'auto');
  //     }
  //   });
  // }

  // if ($('.footnote').length) {
  //   $( document ).ready(function() {
  //     $('.footnote').each(function () {
  //         //Remove default classes
  //         $(this).removeClass('right-edge');
  //         $(this).removeClass('left-edge');
  //         var pos = getPosition(this);
  //         var ww = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  //         if (pos.x > (ww / 2)) {
  //           $(this).addClass('right-edge');
  //         } else {
  //           $(this).addClass('left-edge');
  //         }

  //         // Anchor
  //         var $footnoteAnchor = $(this).find('.footnote__anchor');
  //         var $footnoteLabelAnchor = $(this).find('.footnote__label a');
  //         var targetId = $footnoteAnchor.attr('href').substring(1);
  //         var targetElement = document.getElementById(targetId);
  //         $footnoteLabelAnchor.on('click', function(e) {
  //           e.preventDefault();
  //           var $endNotesAccordion = $('.end-notes-div');
  //           var $endNotesAccordionButton = $endNotesAccordion.find('.accordion__button');
  //           var $endNotesAccordionContent = $endNotesAccordion.find('.accordion__content');
  //           $endNotesAccordionContent.removeClass('collapsed');
  //           $endNotesAccordionButton.addClass('active');
  //           $endNotesAccordionContent.css("height", 'auto');
  //           scrollToElement(targetElement, false);
  //         });
  //     });
  //   });

    // $(window).resize(function () {
    //   waitForFinalEvent(function(){
    //     $('.footnote').each(function () {
    //       $(this).removeClass('left-edge right-edge');
    //       if ($(this).find('.footnote__content').is(':off-right')) {
    //         $(this).addClass('right-edge');
    //       }
    //       if ($(this).find('.footnote__content').is(':off-left')) {
    //         $(this).addClass('left-edge');
    //       }
    //   });
    //   }, 500, "footnote resizes");
    // });
  // }

  // if ($('.accordion-list--end-notes').length) {
  //   $(document).ready(function() {
  //     $('.footnote__anchor').each(function () {
  //       $(this).on('click', function(e) {
  //         var targetId = $(this).attr('href').substring(1);
  //         var targetElement = document.getElementById(targetId);
  //         e.preventDefault();
  //         scrollToElement(targetElement, true);
  //       });
  //     });
  //   });
  // }

  // function getPosition(element) {
  //   var xPosition = 0;
  //   var yPosition = 0;

  //   while (element) {
  //       xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
  //       yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
  //       element = element.offsetParent;
  //   }
  //   return {
  //       x: xPosition,
  //       y: yPosition
  //   };
  // }


  // Scroll to different position on footnotes and endnotes
  // function scrollToElement(element, scrollToFootnote) {
  //   loadLazyImages().then(function () {
  //     setTimeout(function () {
  //       scrollToPosition(element, scrollToFootnote);
  //     }, 100);
  //   });
  // }

  function scrollToPosition(element, scrollToFootnote) {
    var elementRect = $(element)[0].getBoundingClientRect();
    var top = '';
    if ($(scrollToFootnote)) {
      top = elementRect.top + $(window).scrollTop() - 200;
    } else {
      top = elementRect.top;
    }

    $('html, body').animate({
        scrollTop: top,
    }, 400);
  }

  /////////////////////////////////////-+++-
  // Quotable
  if ($('.quotable').length) {
    var amount = $('.quotable__quotable').length;
    var quoteNum = Math.floor(Math.random()*( amount -1+1)+1);
    $( document ).ready(function() {
      for (i = 1; i < amount+1; i++) {
        if(i==quoteNum){
          continue;
        }
        $('.quote-'+i).hide();
      }
    });
  }

  /////////////////////////////////////-+++-
  // Suggested Search Results
  function autocomplete(inp, arr) {
    var currentFocus;
    inp.addEventListener("input", function(e) {
        var a, b, i, val = this.value;
        closeAllLists();
        if (!val) { return false;}
        currentFocus = -1;
        a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        this.parentNode.appendChild(a);
        for (i = 0; i < arr.length; i++) {
          if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
            b = document.createElement("DIV");
            b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
            b.innerHTML += arr[i].substr(val.length);
            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                b.addEventListener("click", function(e) {
                inp.value = this.getElementsByTagName("input")[0].value;
                closeAllLists();
            });
            a.appendChild(b);
          }
        }
    });
    inp.addEventListener("keydown", function(e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
          currentFocus++;
          addActive(x);
        } else if (e.keyCode == 38) {
          currentFocus--;
          addActive(x);
        } else if (e.keyCode == 13) {
          e.preventDefault();
          if (currentFocus > -1) {
            if (x) x[currentFocus].click();
          }
        }
    });
    function addActive(x) {
      if (!x) return false;
      removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = (x.length - 1);
      x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    }
    function closeAllLists(elmnt) {
      var x = document.getElementsByClassName("autocomplete-items");
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != inp) {
        x[i].parentNode.removeChild(x[i]);
      }
    }
  }
  document.addEventListener("click", function (e) {
      closeAllLists(e.target);
  });
  }

  if ($('#search-bar-search-query').length && !$('#search-bar-search-query').hasClass('disable-autocomplete')) {
    autocomplete(document.getElementById("search-bar-search-query"), suggestedResults);
  }

  /////////////////////////////////////-+++-
  // Search Filters
  // $('.search-filters-active-list__clear-button').on('click', function() {
  //   $('.search-filters input:checkbox').prop("checked", false);
  //   $('.search-filters-active-list__list').html('');
  // });
  //
  // $('.search-selected-filter__clear').on('click', function() {
  //   var labelString = $.trim(String($(this).parent().clone().children().remove().end().text()));
  //   $("label:contains('" + labelString + "')").parent().find('input:checkbox').prop("checked", false);
  //   $(this).parent().remove();
  // });

  /////////////////////////////////////-+++-
  // In Page Section Nav
  // $.fn.isInViewport = function() {
  //   var elementTop = $(this).offset().top;
  //   var elementBottom = elementTop + $(this).outerHeight();
  //
  //   var viewportTop = $(window).scrollTop();
  //   var viewportBottom = viewportTop + $(window).height();
  //
  //   return elementBottom > viewportTop && elementTop < viewportBottom;
  // };
  //

  //
  //   $('.in-page-section-nav__dropdown-button').on('click', function() {
  //     $('.in-page-section-nav__dropdown').slideToggle();
  //     $(this).toggleClass('active');
  //   });
  //
  //   $('.in-page-section-nav__dropdown a').on('click', function() {
  //     var newContent = $(this).html();
  //     $('#currently-viewing').html(newContent);
  //     $('html, body').animate({scrollTop: $($(this).attr('href')).offset().top}, 1000);
  //     $('.in-page-section-nav__dropdown a').removeClass('active');
  //     $(this).addClass('active');
  //   });
  //
  //   var headerPos = $('.page-info-header').position();
  //   var navTop = headerPos.top + $('.page-info-header').height();
  //   $(window).scroll(function(){
  //     if ($(window).scrollTop() >= navTop) {
  //         $('.in-page-section-nav').css('margin-top',$('.sticky-header').height()).slideDown();
  //     } else {
  //       $('.in-page-section-nav').slideUp().removeAttr("style");
  //     }
  //   });
  //
  //   $(window).scroll(function(){
  //     // There is only content for 3 chapters + the end notes (chapter 9)
  //     if ($('#chapter-9').isInViewport()) {
  //       var newContent = $('#chapter-9 h2').html();
  //     } else if ($('#chapter-3').isInViewport()) {
  //       var newContent = $('#chapter-3').html();
  //     } else if ($('#chapter-2').isInViewport()) {
  //       var newContent = $('#chapter-2').html();
  //     } else if ($('#chapter-1').isInViewport()) {
  //       var newContent = $('#chapter-1').html();
  //     }
  //     $('#currently-viewing').html(newContent);
  //   });
  //
  // }


  /////////////////////////////////////-+++-
  // Banner on the homepage zooming in on load

    $('.banner').imagesLoaded( function() {
      // images have loaded
      $('.banner').addClass('is-in');
    });

    $('.half-banner').imagesLoaded( function() {
      // images have loaded
      $('.half-banner').addClass('is-in');
    });

    // same thing on large image headers
    $('.page-info-header--has-top-image').imagesLoaded( function() {
      // images have loaded
      $('.page-info-header--has-top-image').addClass('is-in');
    });

    /////////////////////////////////////-+++-
    // Change style of in-page-header if the meta section changes in height

    if( $('.page-info-header__meta').length ) {
      var pageInfoHeaderMetaHeightVal = 0;
      var pageInfoHeaderMetaHeightMinVal = 68; // magic number

      var pageInfoHeaderMetaHeight = (function () {
          $('.page-info-header__meta').removeClass('is-tall');
          pageInfoHeaderMetaHeightVal = $('.page-info-header__meta').outerHeight();

          if (pageInfoHeaderMetaHeightVal > pageInfoHeaderMetaHeightMinVal) {
            $('.page-info-header__meta').addClass('is-tall');
          }
      });

      $(document).ready(function () {
        pageInfoHeaderMetaHeight();
      });

      $(window).resize(function () {
          waitForFinalEvent(function(){
            pageInfoHeaderMetaHeight();
          }, 500, "page info header meta height style change");
      });
    }
  ///////////////////////////////////////-+++-
  // Header authors.
  var $authorList = $('.page-info-header__authors');
  if ($authorList) {
    var $authors = $authorList.children('li');
    if ($authors.length >= 4) {
      $authors.each(function() {
        // Find the title wrapper element, and get widths for comparison.
        var $wrapper = $(this).find('.page-info-header__author-title');
        var childWidth = $(this).outerWidth();
        var parentWidth = $authorList.width();
        // Check if author element width exceeds 20% of parent width
        if (childWidth > 0.2 * parentWidth) {
          var text = $wrapper.text().trim();
          var halfwayIndex = Math.ceil(text.length / 2);

          // Adjust halfwayIndex to the nearest space location if it's greater than 0
          if (halfwayIndex > 0) {
            var firstSpaceIndex = text.lastIndexOf(' ', halfwayIndex);
            var secondSpaceIndex = text.lastIndexOf(' ', text.substring(halfwayIndex));

            if (Math.abs(firstSpaceIndex - halfwayIndex) < Math.abs(secondSpaceIndex - halfwayIndex)) {
              halfwayIndex = firstSpaceIndex;
            } else {
              halfwayIndex = secondSpaceIndex;
            }
          }

          // Split text into two lines and update the wrapper element with HTML content.
          var firstLine = text.substring(0, halfwayIndex);
          var secondLine = text.substring(halfwayIndex).trim();
          $wrapper.empty().html(firstLine + '<br>' + secondLine);
        }
      });
    }
  }

  ///////////////////////////////////////-+++-
  // Pardot form.
  $(document).ready(function() {
    $('.form.pardot-form.email-cta__form').each(function() {
      var $form = $(this);
      var $submitButton = $form.find('.email-cta__submit input[type="submit"]');
      var $formAction = $form.find('.visually-hidden input[name="pardot_form_action"]').val();
      var $emailField = $form.find('input[type="email"]');
      var $zipField = $form.find('input[name="zip"]');
      var $extraField = $form.find('input[name="pardot_extra_field"]');
      var $firstNameField = $form.find('input[name="firstname"]');
      var $lastNameField = $form.find('input[name="lastname"]');

      function isSpamName(value) {
        if (!value || value.trim() === '') {
          return false;
        }
        var trimmed = value.trim();
        var hasUpperCase = /[A-Z]/.test(trimmed);
        var hasLowerCase = /[a-z]/.test(trimmed);
        if (!hasUpperCase || !hasLowerCase) {
          return false;
        }
        var upperCaseCount = (trimmed.match(/[A-Z]/g) || []).length;
        return upperCaseCount > 2;
      }

      var checkFields = function() {
        var isEmailFilled = $emailField.val().trim() !== "";
        var isZipFilled = $zipField.val().trim() !== "";
        var isExtraFieldEmpty = $extraField.val().trim() === "";

        var firstNameValue = $firstNameField.length ? $firstNameField.val().trim() : '';
        var lastNameValue = $lastNameField.length ? $lastNameField.val().trim() : '';
        var firstNameSpam = $firstNameField.length && isSpamName(firstNameValue);
        var lastNameSpam = $lastNameField.length && isSpamName(lastNameValue);
        var spamDetected = firstNameSpam || lastNameSpam;

        var actionValue = "";
        var buttonDisabled = true;

        if (isEmailFilled && isZipFilled && isExtraFieldEmpty && !spamDetected) {
          actionValue = $formAction;
          buttonDisabled = false;
        }

        $form.attr('action', actionValue);
        $submitButton.prop('disabled', buttonDisabled);
      };

      // Add listiner on requiered fields.
      $emailField.on('input', checkFields);
      $zipField.on('input', checkFields);
      $extraField.on('input', checkFields);
      $firstNameField.on('input', checkFields);
      $lastNameField.on('input', checkFields);
    });

    /**
     * Converts links to static text and builds link index for print.
     */
    function optimizeLinksForPrinting() {
      var counter = 1;
      var linksIndex = [];
      var $bodyLinks = $('.field-content__main, .featured-series__collection-link').find('a:not([href^="#"]), iframe[src*="youtube.com"], iframe[src*="vimeo.com"], audio').not('.footnote__citations-wrapper a, .footnotes a');

      // Process each non-footnote link.
      $bodyLinks.each(function () {
        var $element = $(this);

        if ($element.is('iframe')) {
          var linkURL = decodeOembedVideoUrl($element.attr('src'));
          var linkText = $element.attr('title');
        } else if ($element.is('a')) {
          var linkURL = $element.attr('href');
          var linkText = $element.text();
        } else if ($element.is('audio')) {
          var source = $element.find('source');
          var linkURL = source.attr('src');
          var linkText = 'Audio';
        }

        // Create static version.
        if (linkText.length > 0) {
          // Add to index.
          linksIndex.push({
            counter: counter,
            text: linkText,
            url: linkURL,
          });

          // Add static link to the page.
          var staticFootnote =
            $('<span class="body_link__static">' +
              ($element.is('iframe') ? '<span class="link-title">' + linkText + '</span>' : '') +
              '<span class="link-number">[link-' + counter + ']</span>' +
            '</span>');
          $element.after(staticFootnote);
          counter++;
        }
      });

      // Build and append link index
      if (linksIndex.length > 0) {
        var indexHtml = '<ul class="links__index">' +
                       '<h2 class="links__index-title">Links</h2>';

        linksIndex.forEach(function (item) {
          indexHtml += '<li>' +
            '<span class="links__index-number">link-' + item.counter + ':</span> ' +
            '<span class="links__index-text">' + item.text + '</span> ' +
            '<a class="links__index-url" href="' + item.url + '">' + item.url + '</a>' +
          '</li>';
        });

        indexHtml += '</ul>';
        $('body').append(indexHtml);
      }
    }

    /**
     * Converts footnote citation links to static spans for printing
     * This prevents footnote links from appearing as clickable elements in printed output
     */
    // function optimizeFootlinksForPrinting() {
    //   // Find all footnote citation wrapper elements
    //   $('.footnote__citations-wrapper').each(function () {
    //     // Get the link element and its text content
    //     var $link = $(this).find('.footnote__anchor');
    //     var linkText = $link.text();

    //     // Create a new static span element with the link text
    //     var staticFootnote = $('<span class="footnote__static">[' + linkText + ']</span>');
    //     $(this).before(staticFootnote);
    //   });
    // }

    /**
     * Prepares iframes for printing by maintaining their dimensions
     * This ensures iframes display correctly in printed output by preserving
     * their original height and width values
     */
    function optimizeIframesForPrint() {
      $('.wysiwyg-styles iframe').each(function () {
        var height = $(this).css('height');
        var width = $(this).css('width');
        var src = $(this).attr('src');
        var $self = $(this);

        // Exclude YouTube and Vimeo iframes
        if (src && (src.includes("youtu.be") || src.includes("youtube.com") || src.includes("vimeo.com"))) {
          getThumbnailFromOembedUrl(src, function(thumbnailUrl) {
            if (thumbnailUrl) {
              var staticVideo = $('<div class="video-embed__static"></div>');

              var thumbnailImage = $('<img>', {
                src: thumbnailUrl,
                alt: 'Video thumbnail',
                class: 'video-thumbnail',
                style: 'width:100%; height:auto;'
              });

              staticVideo.append(thumbnailImage);
              $self.before(staticVideo);
            }
          });
        }

        // Only process iframes that have a defined height
        else if (height && height !== 'auto') {
          $(this).css({
            'width': width,
            'height': height,
            'min-height': height,
          });
        }
      });

      // Extract and render static map from <noscript>.
      $('.vis-d3-maps-choropleth').each(function() {
        var element = $(this);
        var noscriptContent = element.find("noscript").text();
        var imgMatch = noscriptContent.match(/<img[^>]+>/);

        if (imgMatch) {
          element.append(imgMatch[0]);
        }
      });
    }

    /**
     * Fetches the thumbnail image URL for a given YouTube or Vimeo video
     * by extracting the video ID from the oEmbed URL, and then either fetching
     * the thumbnail from YouTube's image service or Vimeo's oEmbed API.
     *
     * @param {string} oembedUrl - The oEmbed URL containing the video source URL.
     * @param {function} callback - The callback function to return the thumbnail URL.
     */
    function getThumbnailFromOembedUrl(oembedUrl, callback) {
      var decodedUrl = decodeOembedVideoUrl(oembedUrl);
      if (!decodedUrl) return;

      // If the URL is from YouTube
      if (decodedUrl.includes("youtube.com") || decodedUrl.includes("youtu.be")) {
        var videoId = extractYouTubeVideoId(decodedUrl);

        if (videoId) {
          var thumbnailUrl = 'https://img.youtube.com/vi/' + videoId + '/maxresdefault.jpg';
          callback(thumbnailUrl);
        } else {
          console.error('No valid videoId found for YouTube.');
          callback(null);
        }
      }

      // If the URL is from Vimeo
      else if (decodedUrl.includes("vimeo.com")) {
        var videoIdMatch = decodedUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);

        if (videoIdMatch) {
          var videoId = videoIdMatch[1];
          var thumbnailUrl = 'https://vumbnail.com/' + videoId + '.jpg';
          callback(thumbnailUrl);
        } else {
          console.error('No valid videoId found for Vimeo.');
          callback(null);
        }
      }

      else {
        console.error('URL is not recognized as YouTube or Vimeo.');
        callback(null);
      }
    }

    function extractYouTubeVideoId(url) {
      var patterns = [
        /[?&]v=([a-zA-Z0-9_-]{11})/,
        /\/live\/([a-zA-Z0-9_-]{11})/,
        /youtu\.be\/([a-zA-Z0-9_-]{11})/,
        /\/embed\/([a-zA-Z0-9_-]{11})/
      ];
      for (var i = 0; i < patterns.length; i++) {
        var match = url.match(patterns[i]);
        if (match) return match[1];
      }
      return null;
    }

    /**
     * Decodes the original YouTube or Vimeo video URL from an oEmbed URL
     * @param {string} oembedUrl - The oEmbed URL containing the encoded video URL
     * @returns {string|null} - The decoded video URL, or null if not found
     */
    function decodeOembedVideoUrl(oembedUrl) {
      try {
        var parsedUrl = new URL(oembedUrl, window.location.href);
        var isSameHostname = parsedUrl.hostname === window.location.hostname;

        if (!isSameHostname) return oembedUrl;

        var queryString = oembedUrl.split('?')[1];
        if (!queryString) return null;

        var urlParams = new URLSearchParams(queryString);
        var encodedUrl = urlParams.get('url');

        if (!encodedUrl) return null;

        return decodeURIComponent(encodedUrl);
      } catch (error) {
        console.error('Error decoding oEmbed video URL:', error);
        return null;
      }
    }

    function hideEmptyTextElements() {
      $('.chapter > p').each(function() {
        var texto = $(this).html().replace(/&nbsp;/g, ' ').trim();
        if (texto === '') {
          $(this).addClass('empty-string');
        }
      });
    }

    /**
     * Removes static spans that were created for printing
     * This restores the original footnotes and body links to their interactive state
     * by removing the static text versions that were added for print
     */
    function removeStaticPrintSpans() {
      // Find and remove all static spans that were created for printing.
      $('.links__index, .body_link__static, .footnote__static, .vis-d3-maps-choropleth img, .video-embed__static').each(function () {
        $(this).remove();
      });

      // Remove classes added for printing
      $('.empty-string').removeClass('empty-string');
    }

    // Prepare links and iframes for print.
    $(window).on('beforeprint', function () {
      optimizeLinksForPrinting();
      // optimizeFootlinksForPrinting();
      optimizeIframesForPrint();
      hideEmptyTextElements();
    });

    // Restore links after printing.
    $(window).on('afterprint', function () {
      removeStaticPrintSpans();
    });
  });

  var loadLazyImages = function() {
    document.querySelectorAll('[decoding="async"]').forEach(function (element) {
      element.decoding = 'sync';
    });

    var images = [];
    var lazyImages = document.querySelectorAll('[loading="lazy"]');
    lazyImages.forEach(function (image) {
      images.push(image);
    });

    function loadImages(images) {
      return images.reduce(function(promise, image) {
        // This line will wait for the last async function to finish.
        // The first iteration uses an already resolved Promise
        // so, it will immediately continue.
        // https://stackoverflow.com/a/49499491/231914
        return promise.then(function() {
          image.removeAttribute("loading");
          return image.decode();
        });
      }, Promise.resolve());
    }

    return loadImages(images);
  }

}(jQuery, Drupal));
